import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Mail } from 'lucide-react';
import { Button } from '../ui/button';
import { companyInfo } from '../../data/mock';
import { useEstimateModal } from '../EstimateModalContext';

const CTASection = () => {
  const { openModal } = useEstimateModal();
  
  return (
    <section className="py-12 md:py-16 bg-[#3D5A47] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#B5D43B]/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#B5D43B]/5 rounded-full blur-3xl" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full mb-8">
            <div className="w-2 h-2 rounded-full bg-[#B5D43B] animate-pulse" />
            <span className="text-sm font-medium text-white/80">
              Free, no-obligation consultation
            </span>
          </div>

          {/* Headline */}
          <h2 className="text-white heading-2 mb-6">
            Ready to Take Control of Your Energy?
          </h2>
          
          {/* Subheadline */}
          <p className="text-gray-300 text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
            Get a personalised energy assessment and discover how much you could save. 
            No pressure, no obligations — just honest advice from local experts.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10">
            <Button 
              onClick={openModal}
              className="btn-primary gap-2 text-base px-8 py-4 h-auto w-full sm:w-auto flex items-center"
            >
              <span className="flex flex-col items-start leading-tight">
                <span>Get Your Free Estimate</span>
                <span className="text-xs opacity-80 font-normal">Takes only 30 secs</span>
              </span>
              <ArrowRight className="w-4 h-4" />
            </Button>
            <a href={`tel:${companyInfo.phone}`}>
              <Button className="bg-white/10 hover:bg-white/20 text-white border-0 rounded-full gap-2 text-base px-8 py-4 h-auto w-full sm:w-auto transition-colors">
                <Phone className="w-4 h-4" />
                Call Us Now
              </Button>
            </a>
          </div>
          
          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-gray-300 text-sm">
            <a 
              href={`tel:${companyInfo.phone}`}
              className="flex items-center gap-2 hover:text-white transition-colors"
            >
              <Phone className="w-4 h-4 text-[#B5D43B]" />
              {companyInfo.phone}
            </a>
            <a 
              href={`mailto:${companyInfo.email}`}
              className="flex items-center gap-2 hover:text-white transition-colors"
            >
              <Mail className="w-4 h-4 text-[#B5D43B]" />
              {companyInfo.email}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
